import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineCornerDownRightIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19.61 16a1.1884 1.1884 0 0 0-.22-.33L14.76 11a1.0002 1.0002 0 0 0-1.3575.0524A1 1 0 0 0 13.35 12.41l2.92 2.92h-7a3 3 0 0 1-3-3V3a1 1 0 0 0-2 0v9.37a4.9997 4.9997 0 0 0 5 5h7l-2.92 2.92a1.0019 1.0019 0 0 0-.2189.3254 1.0016 1.0016 0 0 0 0 .7692 1.0019 1.0019 0 0 0 .545.5412c.1218.0497.2523.075.3839.0742a1 1 0 0 0 .7-.29l4.63-4.63a.9992.9992 0 0 0 .22-.33 1 1 0 0 0 0-.75Z"/>
  </SvgIcon>
}

export default LineCornerDownRightIcon
